import {Component, Input, Output, EventEmitter} from '@angular/core';
import {Distributors} from "../../services/Distributors";
import {User} from "../../services/User";
import {IUser} from "../../interfaces/IUser";
import {Notify} from "../../services/Notify";
import {ILocation} from "../../interfaces/ILocation";
import {Locations} from "../../services/Locations";
import {IDistributor} from "../../interfaces/IDistributor";

const NAME_REGEX = /^[a-zA-Z\s\-]+$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const NAMES_IDENTICAL_ERROR = "'First Name' and 'Last Name' should be different values";

@Component({
  selector: 'rep-card',
  templateUrl: './rep-card.html',
})
export class RepCardCmp {
  @Input() user: IUser = <IUser>{};
  @Input() id: number = 0;
  @Input() showEditButton = true;
  @Output() update = new EventEmitter();
  @Output() beforeUpdate = new EventEmitter();
  @Output() cancelSave = new EventEmitter();

  public editMode = false;
  public copy;
  public saving;
  public location: ILocation = <ILocation>{};
  public distributorsMap = {};
  public distributorsList: IDistributor[] = [];
  public validationErrors:{[field: string]: string} = {};

  constructor(public users: User, public distributors: Distributors, public locations: Locations) {
    this.distributors.loadToMap(this.distributorsMap);
    this.distributors.loadToList(this.distributorsList);
  }

  ngOnChanges() {
    //noinspection TypeScriptValidateTypes
    if (this.showEditButton.toString() === 'false' || this.showEditButton.toString() === '0') {
      this.showEditButton = false;
    }
    if (this.user && !this.user.id && this.showEditButton) {
      this.editMode = true;
    }
    if ((!this.user || !this.user.id || this.id !== this.user.id) && this.id) {
      this.users.getUserInfo(this.id).then((user) => {
        this.user = <IUser>user;
        this.editMode = false;
      }, ()=> {});
    }
  }

  switchEditMode() {
    if (!this.editMode) {
      this.copy = JSON.stringify(this.user);
    } else {
      if (this.copy) {
        this.user = JSON.parse(this.copy);
      }
      this.cancelSave.emit(true);
    }
    this.validationErrors = {};
    this.editMode = !this.editMode;
  }

  formatPhone(phone:string):string {
    if (!phone) return '';
    let digits = phone.replace(/\D/g, '');
    if (digits.length >= 10) {
      return digits.substring(0, 3) + '-' + digits.substring(3, 6) + '-' + digits.substring(6, 10);
    }
    return phone;
  }

  onPhoneInput(event:any) {
    let digits = event.target.value.replace(/\D/g, '').substring(0, 10);
    let v = digits;
    if (digits.length > 6) {
      v = digits.substring(0, 3) + '-' + digits.substring(3, 6) + '-' + digits.substring(6);
    } else if (digits.length > 3) {
      v = digits.substring(0, 3) + '-' + digits.substring(3);
    }
    event.target.value = v;
    this.user.phone = v;
  }

  private validate():boolean {
    this.validationErrors = {};

    let fname = (this.user.fname || '').trim();
    if (!fname) {
      this.validationErrors['fname'] = 'Field is required';
    } else if (fname.length > 120 || !NAME_REGEX.test(fname)) {
      this.validationErrors['fname'] = 'First Name can contain up to 120 letters, spaces or hyphen';
    }

    let lname = (this.user.lname || '').trim();
    if (!lname) {
      this.validationErrors['lname'] = 'Field is required';
    } else if (lname.length > 120 || !NAME_REGEX.test(lname)) {
      this.validationErrors['lname'] = 'Last Name can contain up to 120 letters, spaces or hyphen';
    }

    if (!this.validationErrors['fname'] && !this.validationErrors['lname'] && fname.toLowerCase() === lname.toLowerCase()) {
      this.validationErrors['lname'] = NAMES_IDENTICAL_ERROR;
    }

    if (!this.user.id) {
      let email = (this.user.email || '').trim();
      this.user.email = email;
      if (!email) {
        this.validationErrors['email'] = 'Field is required';
      } else if (!EMAIL_REGEX.test(email)) {
        this.validationErrors['email'] = 'Please enter a valid email address (e.g. name@example.com)';
      }
    }

    if (this.user.phone) {
      this.user.phone = this.formatPhone(this.user.phone);
    }
    let phone = (this.user.phone || '').trim();
    if (!phone) {
      this.validationErrors['phone'] = 'Field is required';
    } else {
      let digits = phone.replace(/\D/g, '');
      if (digits.length < 10) {
        this.validationErrors['phone'] = 'Please enter a phone number in the format 123-456-7890';
      }
    }

    if (this.user.job_title && this.user.job_title.length > 60) {
      this.validationErrors['job_title'] = 'Job Title should contain up to 60 characters';
    }

    return Object.keys(this.validationErrors).length === 0;
  }

  save() {
    if (!this.validate()) {
      let firstError = this.validationErrors[Object.keys(this.validationErrors)[0]];
      let notify = new Notify();
      notify.error(firstError, 'Validation Error');
      return;
    }

    this.beforeUpdate.emit(this.user);
    if (this.user && !this.user.__cancelUpdate) {
      this.saving = true;
      this.users.updateUser(this.user).then((id:number)=> {
          this.saving = false;
          this.copy = null;
          this.editMode = false;
          this.update.emit(this.user);
          let new_id = id || this.user.id;
          if (new_id && this.location.facility_name) {
            this.location.primary_contact_user_id = new_id;
            this.location.__rep_user_id = new_id;
            this.locations.updateLocation(this.location).then(null, (err)=> {
              console.error(err);
              try {
                let n = new Notify();
                n.error("Can't create location record - server error");
              } catch (e) {}
            });
          }
        },
        (response)=> {
          console.error(response);
          this.saving = false;
          let notify = new Notify();
          notify.httpErr(response);
        });
    }
  }
}
